export const TASK_TYPES = [
  'medication',
  'vital-signs',
  'blood-sugar',
  'intake-output',
  'lab',
  'surgery',
  'examination',
] as const;
export type TaskType = (typeof TASK_TYPES)[number];
